import api from './index';

export const agentAPI = {
  chat: (data) => {
    return api.post('/api/agent/chat', data);
  },
  getTask: (taskId) => {
    return api.get(`/api/agent/tasks/${taskId}`);
  }
};
